export default __webpack_public_path__ + "static/media/Rosan-768x768.ab05805b.jpg";